import { render, staticRenderFns } from "./SysMessageTemplateList.vue?vue&type=template&id=93db85d8&scoped=true&"
import script from "./SysMessageTemplateList.vue?vue&type=script&lang=js&"
export * from "./SysMessageTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./SysMessageTemplateList.vue?vue&type=style&index=0&id=93db85d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93db85d8",
  null
  
)

export default component.exports